(() => {
  if (new URLSearchParams(window.location.search).get('source') !== 'featured') return;

  const applyFeaturedContext = () => {
    const standard = document.querySelector('[data-amaca-standard-related]');
    const featured = document.querySelector('[data-amaca-featured-related]');
    if (!standard || !featured) return false;

    standard.hidden = true;
    featured.hidden = false;
    return true;
  };

  if (applyFeaturedContext()) return;

  const observer = new MutationObserver(() => {
    if (applyFeaturedContext()) observer.disconnect();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
